// app.component.ts
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

// MSAL
import {
  MsalService,
  MsalModule,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MsalModule, ToastModule],
  template: `
    <p-toast></p-toast>
    <router-outlet></router-outlet>
  `,
  styles: [``]
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private msal: MsalService,
    private msalBroadcast: MsalBroadcastService,
    @Inject(MSAL_GUARD_CONFIG) private msalConfig: MsalGuardConfiguration
  ) { }

  ngOnInit(): void {
    // MSAL Redirect handling (wichtig für Azure Login)
    this.msal.handleRedirectObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    // Set active account when interaction is complete
    this.msalBroadcast.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
  }

  private checkAndSetActiveAccount(): void {
    const activeAccount = this.msal.instance.getActiveAccount();
    const accounts = this.msal.instance.getAllAccounts();

    if (!activeAccount && accounts.length > 0) {
      this.msal.instance.setActiveAccount(accounts[0]);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
